export default "__VITE_ASSET__Buc7iWms__"